/* global document */

import { useEffect } from "react";

export function useHideImagesOnError() {
  useEffect(() => {
    const hideBrokenImages = () => {
      document.querySelectorAll("img").forEach((img) => {
        if (!img.onerror)
          img.onerror = function () {
            (this as HTMLImageElement).style.display = "none";
          };
      });
    };

    hideBrokenImages();

    const observer = new MutationObserver(() => hideBrokenImages());
    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, []);
}
